import { create } from 'zustand';

export interface TripOffer {
  tripId: string;
  pickup: { lat: number; lng: number };
  drop: { lat: number; lng: number };
  distanceKm: number;
  estimatedFare: number;
  expiresAt: string;
}

interface OfferState {
  offer: TripOffer | null;
  activeTripId: string | null;
  setOffer: (o: TripOffer | null) => void;
  setActiveTripId: (id: string | null) => void;
}

export const useOffer = create<OfferState>((set) => ({
  offer: null,
  activeTripId: null,
  setOffer: (offer) => set({ offer }),
  setActiveTripId: (activeTripId) => set({ activeTripId }),
}));
